import { createAction, props } from "@ngrx/store";
import { IVesselMovement } from "../model/vessel-movement";
import { IQueryResult } from "@pmis3/data-access";
import { IDateTimeRange } from "@pmis3/utils";

export enum VesselMovementActionTypes {
    LoadVesselMovements = "[VesselVisit Page] Load VesselMovements",
    LoadVesselMovementsByDateRange = "[VesselVisit Page] Load VesselMovements by DateRange",
    LoadVesselMovementsSuccess = "[VesselVisit Page] Load VesselMovements Success",
    LoadVesselMovementsFail = "[VesselVisit Page] Load VesselMovements Fail"
}

export enum VesselMovementButtonActions {
    Save = 'save',
    Submit = 'submit'
}

export const LoadVesselMovements = createAction(
  VesselMovementActionTypes.LoadVesselMovements
)

export const LoadVesselMovementsByDateRange = createAction(
  VesselMovementActionTypes.LoadVesselMovementsByDateRange,
  props<{dateRange: IDateTimeRange}>()
);

export const LoadVesselMovementsSuccess = createAction(
  VesselMovementActionTypes.LoadVesselMovementsSuccess,
  props<{result: IQueryResult<IVesselMovement>}>()
);

export const LoadVesselMovementsFail = createAction(
  VesselMovementActionTypes.LoadVesselMovementsFail,
  props<{ error: string }>()
);